


























import { computed, defineComponent, ref } from '@vue/composition-api';
import { InputType } from '@getaccept/lib-ui';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { validateEmail } from '@getaccept/lib-shared/src/helpers';

export default defineComponent({
  props: {
    email: { type: String, default: '' },
    disabled: { type: Boolean },
  },
  setup(props, { emit }) {
    const updatedEmail = ref(props.email);
    const invalidEmail = ref(false);

    const handleEnter = () => {
      if (!validateEmail(updatedEmail.value?.toLowerCase())) {
        invalidEmail.value = true;
        return;
      }

      emit('submit', updatedEmail.value);
    };

    const emailInvalidMessage = computed(() =>
      invalidEmail.value ? t('enter_a_valid_email') : ''
    );

    return { t, updatedEmail, handleEnter, InputType, invalidEmail, emailInvalidMessage };
  },
});
